module.exports = __webpack_public_path__ + "public/img/login_img.71bee4c7.png";